import booleanPointInPolygon from '@turf/boolean-point-in-polygon';

import { mapToPoints } from './geojson';

export function getPathPointFromPolygon(map, polygon) {
  return mapToPoints(map).find((point) =>
    booleanPointInPolygon(point, polygon)
  );
}
